
import Vue from 'vue';
import PolledPaymentCompletion from '@/Payment/PolledPaymentCompletion.vue';
import { PaymentProcessor } from '@/Payment/Enums';

const component = Vue.extend({
    components: {
        PolledPaymentCompletion
    },
    data() {
        return {
            PaymentProcessor
        };
    }
});

export default component;
